import { riderMasterContainerFactory } from 'common/entity/riderMaster/RiderMasterContainer';
import { PjpNavigationActionsBar } from 'common/entity/pjpMaster/create/PjpNavigationActionsBar';
import { PjpBulkViewEmptyState } from 'common/entity/pjpMaster/create/PjpBulkViewEmptyState';

export const CreatePjpRiderMasterContainer = riderMasterContainerFactory({
    EntityEditViewContainer: null,
    EntityImportContainer: null,
    BulkViewEmptyState: PjpBulkViewEmptyState,
    ActionsBar: PjpNavigationActionsBar
});

export default CreatePjpRiderMasterContainer;
